import * as Yup from 'yup'

import { getDailyBudgetValidation } from '../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/fields'

import { BUDGET_DAILY } from '../../../Multiplatform/CampaignForms/fields'

export const getValidationSchema = ({ remainingBudget, campaign }) => {
  const startDate = campaign.date_start
  const endDate = campaign.date_stop

  if (remainingBudget || remainingBudget === 0) {
    return Yup.object({
      [BUDGET_DAILY]: Yup.number().test({
        name: 'Edit campaign daily budget validation based on number of days',

        test: (value, context) => {
          return getDailyBudgetValidation({
            remainingBudget,
            value,
            context,
            startDate,
            endDate,
            initialCampaignBudgetDaily: campaign?.[BUDGET_DAILY]
          })
        }
      })
    })
  } else {
    return {
      [BUDGET_DAILY]: Yup.number().required('Daily budget is required')
    }
  }
}
